/**
 * Scroll reveal for institutional desktop v2 (specs 0102 / 0104).
 * Targets [data-gm-reveal] under .gm-page-sustentabilidade or .gm-page-sobre-nos.
 */
(function () {
  'use strict';

  function hardShow(el) {
    el.classList.add('is-revealed', 'gm-reveal--ready');
    el.style.transition = 'none';
    el.style.opacity = '1';
    el.style.transform = 'none';
  }

  function show(el) {
    el.classList.add('is-revealed', 'gm-reveal--ready');
  }

  function initRoot(root) {
    if (!root) return;

    var els = Array.prototype.slice.call(root.querySelectorAll('[data-gm-reveal]'));
    if (!els.length) return;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(hardShow);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          show(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -5% 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });

    window.setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains('is-revealed')) hardShow(el);
      });
    }, 1400);
  }

  function init() {
    initRoot(document.querySelector('.gm-page-sustentabilidade'));
    initRoot(document.querySelector('.gm-page-sobre-nos'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
